import './footer.scss';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer__wrapper">
          <a href="https://rawg.io/apidocs" className="footer-text">Based on RAWG Database API</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;